import { render } from "./ExerciseTile.vue?vue&type=template&id=3ee418f0"
import script from "./ExerciseTile.vue?vue&type=script&lang=js"
export * from "./ExerciseTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__